/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useMemo } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React example components
import Sidenav from "examples/Sidenav";
// Soft UI Dashboard PRO React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Soft UI Dashboard PRO React routes
import routes from "routes";
import jobproviderroute from "SidenavRoutes/jobproviderroute";

// Soft UI Dashboard PRO React contexts
import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images
import brand from "assets/images/logo-ct.png";

// routes components
import Login from "pages/Login/Login";
import LoginNew from "pages/Login/LoginNew";
import LoginVendor from "pages/Login/LoginVendor";
import SignUpBasic from "layouts/authentication/sign-up/basic";
// import SignUpCover from "layouts/authentication/sign-up/cover";
// import AdminRegistration from "pages/Admin/registrationPage";
import Channelprtnerregister from "pages/Channelpartner/channelprtnerregister";
import Centerreg from "pages/Center/centerreg";
import CenterHeadRegistration from "pages/Centerhead/centerHeadRegistration";
import CenterHeadRegistration2 from "pages/Centerhead/centerHeadRegistration2";
import JobFairRegistration from "pages/Jobfair/jobfairRegistration";
import SuperAdminRegistraion from "pages/Suparadmin/superAdminRegisteration";
import Jobseekarreg from "pages/Jobseekar/jobseekarreg";
import Jobproviderreg from "pages/Jobprovider/jobproviderreg";
import CounsellourRegistration from "pages/Counsellour/counselloourRegistration";
import Forgotpassword1 from "pages/Forgotpassword/forgotpassword1";
import Roletable from "pages/roletable/roletable";
import RecommendSearch from "pages/CandidateSearch/recommendSearch";
import RecommendShortlist from "pages/CandidateSearch/recommendShortlist";
import ViewCandidates from "pages/CandidateSearch/viewCandidates";
// import JobPosting from "pages/CandidateSearch/JobPostings/jobPosting";
import Recommandsearchlist from "pages/CandidateSearch/JobPostings/recommendedJobPostSearchList";
import JobProviderpage from "Jobprovider/layout/jobproviderPage";
import JobProviderDashboard from "Jobprovider/layout/jobproviderDashboard";
import NewSearch from "pages/CandidateSearch/newSearch";
import JobPosting from "pages/CandidateSearch/JobPostings/jobPosting";
import CreatePosting from "pages/CandidateSearch/JobPostings/createPosting";
import PrivateRoute from "utils/PrivateRoute";
import Charts from "layouts/pages/charts";
import JobPostings from "Jobprovider/layout/jobPostings";
import PostProfile from "Jobprovider/layout/postProfile";
import UserMIS from "Jobprovider/layout/userMIS";
import JobRegistration from "Jobprovider/layout/jobRegistration";
import Register from "pages/Register";
import SRSLogin from "pages/Login/SrsLogin";
// import CounselorPage from "Counselor/layout/counselorsPage";
import Channelpartnerpage from "Channelpartner/layout/channelpartnerpage";
import Channlpartnerdashboard from "Channelpartner/layout/channlpartendashboard";
import JobRequestPage from "Channelpartner/layout/JobRequestPage";
import CandidatesList from "Channelpartner/layout/CandidatesList";
import Assistant from "Channelpartner/layout/Assistant";
import Mis from "Channelpartner/layout/Mis";
import CoursesAssigned from "Channelpartner/layout/CoursesAssigned";
import StudentList from "Channelpartner/layout/StudentList";
// import "antd/dist/reset.css";

export default function App() {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  const [cpType, setCPtype] = useState("");
  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route, i) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return (
          <Route exact element={<PrivateRoute />} key={i}>
            <Route exact path={route.route} element={route.component} key={route.key} />
          </Route>
        );
      }

      return null;
    });

  const configsButton = (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.5rem"
      height="3.5rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="default" color="inherit">
        settings
      </Icon>
    </SoftBox>
  );

  // if (window.location.host.split(".")[0] === "srslogin") {
  //   setCPtype("SRS");
  // }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={brand}
            brandName="Soft UI Dashboard PRO"
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          {/* <Configurator /> */}
      {/* {configsButton} */}
      {/* {configsButton} *
        </>
      )} */}

      {/* {layout === "vr" && <Configurator />} */}
      <Routes>
        {getRoutes(routes)}
        <Route path="*" element={<Navigate to="/login" />} />
        {/* Login pages */}
        {/* <Route path="/login" element={<SRSLogin />} /> */}
        {/* <Route path="/login" element={cpType === "SRS" ? <Login /> : <SRSLogin />} /> */}
        <Route
          path="/login"
          element={
            window.location.host.split(".")[0] === "srslogin" ? (
              <Login />
            ) : window.location.host.split(".")[0] === "mysbalogin" ? (
              <LoginNew />
            ) : (
              <LoginVendor />
            )
          }
        />
        <Route path="/forgotpassword1" element={<Forgotpassword1 />} />
        {/* Login pages */}
        {/* srs routes */}
        {/* <Route path="/" element={<Channelpartnerpage />}>
          <Route path="profile" element={<Channlpartnerdashboard />} />
          <Route path="job-request" element={<JobRequestPage />} />
        </Route> */}
        <Route exact element={<PrivateRoute />}>
          <Route path="/profile" element={<Channelpartnerpage />}>
            <Route path="" element={<Channlpartnerdashboard />} />
          </Route>
        </Route>
        <Route exact element={<PrivateRoute />}>
          <Route path="/job-request" element={<Channelpartnerpage />}>
            <Route path="" element={<JobRequestPage />} />
          </Route>
        </Route>
        <Route exact element={<PrivateRoute />}>
          <Route path="/internship-request" element={<Channelpartnerpage />}>
            <Route path="" element={<JobRequestPage />} />
          </Route>
        </Route>
        <Route exact element={<PrivateRoute />}>
          <Route path="/candidates" element={<Channelpartnerpage />}>
            <Route path="" element={<CandidatesList />} />
          </Route>
        </Route>
        <Route exact element={<PrivateRoute />}>
          <Route path="/phygitalvolunteer" element={<Channelpartnerpage />}>
            <Route path="" element={<Assistant />} />
          </Route>
        </Route>
        <Route exact element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Channelpartnerpage />}>
            <Route path="" element={<Mis />} />
          </Route>
        </Route>
        {/* srs routes */}
        {/* Skilling Partner routes */}
        <Route exact element={<PrivateRoute />}>
          <Route path="/courses-assigned" element={<Channelpartnerpage />}>
            <Route path="" element={<CoursesAssigned />} />
          </Route>
        </Route>
        <Route exact element={<PrivateRoute />}>
          <Route path="/candidates-list" element={<Channelpartnerpage />}>
            <Route path="" element={<StudentList />} />
          </Route>
        </Route>
      </Routes>
    </ThemeProvider>

    // );
  );
}
